import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import Base from './base';
import { CANCEL_KEYS } from '../utils/consts';
/**
 * `Service` The AutoCallouts Bebop service
 * https://platform.stoplight.autodesk.com/docs/autocallouts-backend-api-bebop/branches/main/qg8gh8n7o70pg-autocallouts
 */
var AutoCallouts = /*#__PURE__*/function (_Base) {
  /**
   * Create the AutoCallouts service instance.
   *
   * @param sdk - the SDK instance
   */
  function AutoCallouts(sdk) {
    var _this;
    _classCallCheck(this, AutoCallouts);
    _this = _callSuper(this, AutoCallouts, [sdk]);
    _this.createScopeCancelTokenMap = new Map();
    return _this;
  }

  /**
   * Static getter of the class name
   * @returns The detail property name used by SDK instance.
   */
  _inherits(AutoCallouts, _Base);
  return _createClass(AutoCallouts, [{
    key: "createScope",
    value: (
    /**
     * Create a scope for a folder
     * https://platform.stoplight.autodesk.com/docs/autocallouts-backend-api-bebop/branches/main/1dmrk21wvvy6p-create-scope
     *
     * @param projectId - the project id.
     * @param payload - the request payload.
     * @param config - configurable object to overwrite request parameters.
     *
     * @returns a promise with scopes data.
     */
    function () {
      var _createScope = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, payload, config) {
        var _this2 = this;
        var folderUrn, path, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              folderUrn = payload.scopeGroup.groupId;
              config = _defineProperty({}, CANCEL_KEYS, _extends({
                getter: function getter() {
                  return _this2.createScopeCancelTokenMap.get(folderUrn);
                },
                setter: function setter(token) {
                  return _this2.createScopeCancelTokenMap.set(folderUrn, token);
                },
                clearer: function clearer() {
                  return _this2.createScopeCancelTokenMap["delete"](folderUrn);
                }
              }, config));
              path = "projects/".concat(projectId, "/scopes");
              _context.next = 5;
              return this.HttpService.autoCalloutsV1.post(path, payload, config);
            case 5:
              response = _context.sent;
              return _context.abrupt("return", response.data);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createScope(_x, _x2, _x3) {
        return _createScope.apply(this, arguments);
      }
      return createScope;
    }()
    /**
     * Delete scope with scopeId.
     * https://platform.stoplight.autodesk.com/docs/autocallouts-backend-api-bebop/branches/main/zc0q98ljqizas-delete-scope
     *
     * @param projectId - the project id.
     * @param scopeId - the scope id, which is the folder id.
     * @param config - configurable object to overwrite request parameters.
     *
     * @returns a promise with void.
     */
    )
  }, {
    key: "deleteScope",
    value: (function () {
      var _deleteScope = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, scopeId, config) {
        var path;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              path = "projects/".concat(projectId, "/scopes/").concat(scopeId);
              _context2.next = 3;
              return this.HttpService.autoCalloutsV1["delete"](path, config);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function deleteScope(_x4, _x5, _x6) {
        return _deleteScope.apply(this, arguments);
      }
      return deleteScope;
    }()
    /**
     * Batch get scopes with folderUrns.
     * https://platform.stoplight.autodesk.com/docs/autocallouts-backend-api-bebop/branches/main/ydybocr51nrqa-query-scopes
     *
     * @param projectId - the project id.
     * @param payload - the request body, with shape of \{ groupType: 'folder', groupIds: ['folder-urn'] \}
     * @param config - configurable object to overwrite request parameters.
     *
     * @returns a promise \{ scopes \}.
     */
    )
  }, {
    key: "batchGetScopes",
    value: (function () {
      var _batchGetScopes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId, payload, config) {
        var path, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              path = "projects/".concat(projectId, "/scopes:query");
              _context3.next = 3;
              return this.HttpService.autoCalloutsV1.post(path, payload, config);
            case 3:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function batchGetScopes(_x7, _x8, _x9) {
        return _batchGetScopes.apply(this, arguments);
      }
      return batchGetScopes;
    }()
    /**
     * Regenerate autocallouts under a scope.
     * https://platform.stoplight.autodesk.com/docs/autocallouts-backend-api-bebop/branches/main/5wwm2fhgtd7pt-reprocess-scope
     *
     * @param projectId - the project id.
     * @param scopeId - the scope id, which is the folder id.
     * @param payload - the request body.
     * @param config - configurable object to overwrite request parameters.
     *
     * @returns a promise with void.
     */
    )
  }, {
    key: "reprocess",
    value: (function () {
      var _reprocess = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(projectId, scopeId) {
        var payload,
          config,
          path,
          _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              payload = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
              config = _args4.length > 3 ? _args4[3] : undefined;
              path = "projects/".concat(projectId, "/scopes/").concat(scopeId, ":reprocess");
              _context4.next = 5;
              return this.HttpService.autoCalloutsV1.post(path, payload, config);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function reprocess(_x10, _x11) {
        return _reprocess.apply(this, arguments);
      }
      return reprocess;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'AutoCallouts';
    }
  }]);
}(Base);
export default AutoCallouts;